// BASE COLOR VARIABLES

export const colors = {
  white: '#FFF',
  ascentialTeal: '#115C72',
  borderGray: '#D6D6D6',
  fontBlock: '#121923',
  filterList: '#5B5B5B',
  navy: '#003399',
  opaqueNavy: 'rgba(0, 51, 153, 0.12)'
};

// BASE FONT VARIABLES
export const fonts = {
  regular: 'NunitoSans Regular',
  light: 'NunitoSans Light',
  medium: 'NunitoSans Medium',
  bold: 'NunitoSans Bold'
};

// BASE BREAKPOINT VARIABLES
export const breakpoints = {
  height: 850,
  width: 800
};
